// // src/pages/client/ClientDashboard.jsx
// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
// import {
//   FiBarChart2,
//   FiCalendar,
//   FiMessageSquare,
//   FiFileText,
//   FiUser,
//   FiSettings,
//   FiLogOut,
//   FiBell,
//   FiArrowRight,
//   FiTrendingUp,
//   FiClock,
// } from "react-icons/fi";
// import { useClient } from "../context/ClientContext";
// import axios from "axios";

// function ClientDashboard() {
//   const [dashboardData, setDashboardData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const { client, logout } = useClient();

//   useEffect(() => {
//     fetchDashboardData();
//   }, []);

//   const fetchDashboardData = async () => {
//     try {
//       const token = localStorage.getItem("agritech-client-token");
//       const response = await axios.get(
//         "https://agri-back-mauve.vercel.app/api/client-portal/dashboard",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       if (response.data.success) {
//         setDashboardData(response.data.data);
//       }
//     } catch (error) {
//       console.error("Error fetching dashboard data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
//           <p className="text-gray-600">Loading your dashboard...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Header */}
//       <header className="bg-white shadow-sm border-b border-gray-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center h-16">
//             <div className="flex items-center">
//               <Link
//                 to="/client/dashboard"
//                 className="flex items-center space-x-3"
//               >
//                 <div className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center">
//                   <span className="text-white font-bold text-sm">A</span>
//                 </div>
//                 <span className="text-gray-900 font-bold text-lg">
//                   Afrikonsults
//                 </span>
//               </Link>
//               <span className="ml-4 text-sm text-gray-500">Client Portal</span>
//             </div>

//             <div className="flex items-center space-x-4">
//               <button className="p-2 text-gray-400 hover:text-gray-600 relative">
//                 <FiBell size={20} />
//                 {dashboardData?.stats.unreadMessages > 0 && (
//                   <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
//                 )}
//               </button>

//               <div className="flex items-center space-x-3">
//                 <div className="text-right">
//                   <p className="text-sm font-medium text-gray-900">
//                     {client?.profile?.personalInfo?.fullName || "Client"}
//                   </p>
//                   <p className="text-xs text-gray-500">{client?.email}</p>
//                 </div>
//                 <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
//                   <FiUser className="text-green-600" size={16} />
//                 </div>
//               </div>

//               <button
//                 onClick={logout}
//                 className="p-2 text-gray-400 hover:text-gray-600"
//                 title="Logout"
//               >
//                 <FiLogOut size={18} />
//               </button>
//             </div>
//           </div>
//         </div>
//       </header>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         {/* Welcome Section */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="mb-8"
//         >
//           <h1 className="text-3xl font-bold text-gray-900">
//             Welcome back, {client?.profile?.personalInfo?.fullName || "Client"}!
//           </h1>
//           <p className="text-gray-600 mt-2">
//             Here's what's happening with your farm and projects today.
//           </p>
//         </motion.div>

//         {/* Stats Grid */}
//         {dashboardData && (
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.1 }}
//               className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
//             >
//               <div className="flex items-center">
//                 <div className="p-3 bg-blue-100 rounded-lg">
//                   <FiBarChart2 className="text-blue-600" size={24} />
//                 </div>
//                 <div className="ml-4">
//                   <p className="text-sm font-medium text-gray-600">
//                     Active Projects
//                   </p>
//                   <p className="text-2xl font-bold text-gray-900">
//                     {dashboardData.stats.activeProjects}
//                   </p>
//                 </div>
//               </div>
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.2 }}
//               className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
//             >
//               <div className="flex items-center">
//                 <div className="p-3 bg-green-100 rounded-lg">
//                   <FiCalendar className="text-green-600" size={24} />
//                 </div>
//                 <div className="ml-4">
//                   <p className="text-sm font-medium text-gray-600">
//                     Upcoming Appointments
//                   </p>
//                   <p className="text-2xl font-bold text-gray-900">
//                     {dashboardData.stats.upcomingAppointments}
//                   </p>
//                 </div>
//               </div>
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.3 }}
//               className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
//             >
//               <div className="flex items-center">
//                 <div className="p-3 bg-purple-100 rounded-lg">
//                   <FiMessageSquare className="text-purple-600" size={24} />
//                 </div>
//                 <div className="ml-4">
//                   <p className="text-sm font-medium text-gray-600">
//                     Unread Messages
//                   </p>
//                   <p className="text-2xl font-bold text-gray-900">
//                     {dashboardData.stats.unreadMessages}
//                   </p>
//                 </div>
//               </div>
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.4 }}
//               className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
//             >
//               <div className="flex items-center">
//                 <div className="p-3 bg-orange-100 rounded-lg">
//                   <FiFileText className="text-orange-600" size={24} />
//                 </div>
//                 <div className="ml-4">
//                   <p className="text-sm font-medium text-gray-600">
//                     Recent Reports
//                   </p>
//                   <p className="text-2xl font-bold text-gray-900">
//                     {dashboardData.stats.recentReports}
//                   </p>
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         )}

//         {/* Quick Actions */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.5 }}
//           className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
//         >
//           {/* Recent Projects */}
//           <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-gray-900">
//                 Recent Projects
//               </h3>
//               <Link
//                 to="/client/projects"
//                 className="text-green-600 hover:text-green-700 text-sm font-medium"
//               >
//                 View All
//               </Link>
//             </div>
//             <div className="space-y-4">
//               {dashboardData?.recentProjects?.map((project) => (
//                 <div
//                   key={project._id}
//                   className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg"
//                 >
//                   <div>
//                     <p className="font-medium text-gray-900">{project.title}</p>
//                     <p className="text-sm text-gray-500">
//                       {project.assignedConsultant?.name}
//                     </p>
//                   </div>
//                   <div className="text-right">
//                     <span
//                       className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
//                         project.status === "active"
//                           ? "bg-green-100 text-green-800"
//                           : project.status === "completed"
//                           ? "bg-gray-100 text-gray-800"
//                           : "bg-yellow-100 text-yellow-800"
//                       }`}
//                     >
//                       {project.status}
//                     </span>
//                     <div className="w-20 bg-gray-200 rounded-full h-2 mt-2">
//                       <div
//                         className="bg-green-600 h-2 rounded-full"
//                         style={{
//                           width: `${project.progress?.percentage || 0}%`,
//                         }}
//                       ></div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Upcoming Appointments */}
//           <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-gray-900">
//                 Upcoming Appointments
//               </h3>
//               <Link
//                 to="/client/appointments"
//                 className="text-green-600 hover:text-green-700 text-sm font-medium"
//               >
//                 Schedule
//               </Link>
//             </div>
//             <div className="space-y-4">
//               {dashboardData?.upcomingAppointments?.map((appointment) => (
//                 <div
//                   key={appointment._id}
//                   className="p-3 border border-gray-200 rounded-lg"
//                 >
//                   <div className="flex justify-between items-start">
//                     <div>
//                       <p className="font-medium text-gray-900">
//                         {appointment.title}
//                       </p>
//                       <p className="text-sm text-gray-500">
//                         {appointment.consultantId?.name}
//                       </p>
//                     </div>
//                     <span
//                       className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
//                         appointment.status === "scheduled"
//                           ? "bg-blue-100 text-blue-800"
//                           : appointment.status === "confirmed"
//                           ? "bg-green-100 text-green-800"
//                           : "bg-gray-100 text-gray-800"
//                       }`}
//                     >
//                       {appointment.status}
//                     </span>
//                   </div>
//                   <div className="mt-2 text-sm text-gray-600">
//                     {new Date(appointment.scheduledDate).toLocaleDateString()} •
//                     {new Date(appointment.scheduledDate).toLocaleTimeString()}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Recent Reports */}
//           <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-gray-900">
//                 Recent Reports
//               </h3>
//               <Link
//                 to="/client/reports"
//                 className="text-green-600 hover:text-green-700 text-sm font-medium"
//               >
//                 View All
//               </Link>
//             </div>
//             <div className="space-y-4">
//               {dashboardData?.recentReports?.map((report) => (
//                 <div
//                   key={report._id}
//                   className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg"
//                 >
//                   <div>
//                     <p className="font-medium text-gray-900">{report.title}</p>
//                     <p className="text-sm text-gray-500 capitalize">
//                       {report.type.replace("-", " ")}
//                     </p>
//                   </div>
//                   <Link
//                     to="/client/reports"
//                     className="text-green-600 hover:text-green-700"
//                   >
//                     <FiArrowRight size={16} />
//                   </Link>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </motion.div>

//         {/* Quick Links */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ delay: 0.6 }}
//           className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4"
//         >
//           <Link
//             to="/client/profile"
//             className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow text-center"
//           >
//             <FiUser className="w-6 h-6 text-green-600 mx-auto mb-2" />
//             <span className="text-sm font-medium text-gray-900">Profile</span>
//           </Link>
//           <Link
//             to="/client/projects"
//             className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow text-center"
//           >
//             <FiTrendingUp className="w-6 h-6 text-blue-600 mx-auto mb-2" />
//             <span className="text-sm font-medium text-gray-900">Projects</span>
//           </Link>
//           <Link
//             to="/client/messages"
//             className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow text-center"
//           >
//             <FiMessageSquare className="w-6 h-6 text-purple-600 mx-auto mb-2" />
//             <span className="text-sm font-medium text-gray-900">Messages</span>
//           </Link>
//           <Link
//             to="/client/appointments"
//             className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow text-center"
//           >
//             <FiCalendar className="w-6 h-6 text-orange-600 mx-auto mb-2" />
//             <span className="text-sm font-medium text-gray-900">
//               Appointments
//             </span>
//           </Link>
//         </motion.div>
//       </div>
//     </div>
//   );
// }

// export default ClientDashboard;

// src/pages/client/ClientDashboard.jsx
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FiBarChart2,
  FiCalendar,
  FiMessageSquare,
  FiFileText,
  FiUser,
  FiLogOut,
  FiBell,
  FiArrowRight,
  FiTrendingUp,
  FiHome,
  FiMenu,
  FiX,
} from "react-icons/fi";
import { useClient } from "../context/ClientContext";
import axios from "axios";

function ClientDashboard() {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { client, logout } = useClient();
  const location = useLocation();
  const navigate = useNavigate();

  // Import your page components
  const ClientProjects = React.lazy(() => import('./ClientProjects'));
  const ClientAppointments = React.lazy(() => import('./ClientAppointments'));
  const ClientMessages = React.lazy(() => import('./ClientMessages'));
  const ClientReports = React.lazy(() => import('./ClientReports'));
  const ClientProfile = React.lazy(() => import('./ClientProfile'));

  const navigationItems = [
    {
      name: "Dashboard",
      href: "/client/dashboard",
      icon: FiHome,
      current: location.pathname === "/client/dashboard",
    },
    {
      name: "Projects",
      href: "/client/projects",
      icon: FiTrendingUp,
      current: location.pathname === "/client/projects",
    },
    {
      name: "Appointments",
      href: "/client/appointments",
      icon: FiCalendar,
      current: location.pathname === "/client/appointments",
    },
    {
      name: "Messages",
      href: "/client/messages",
      icon: FiMessageSquare,
      current: location.pathname === "/client/messages",
    },
    {
      name: "Reports",
      href: "/client/reports",
      icon: FiFileText,
      current: location.pathname === "/client/reports",
    },
    {
      name: "Profile",
      href: "/client/profile",
      icon: FiUser,
      current: location.pathname === "/client/profile",
    },
  ];

  useEffect(() => {
    if (location.pathname === "/client/dashboard") {
      fetchDashboardData();
    }
  }, [location.pathname]);

  const fetchDashboardData = async () => {
    try {
      const token = localStorage.getItem("agritech-client-token");
      const response = await axios.get(
        "https://agri-back-mauve.vercel.app/api/client-portal/dashboard",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setDashboardData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderCurrentPage = () => {
    switch (location.pathname) {
      case "/client/projects":
        return <ClientProjects />;
      case "/client/appointments":
        return <ClientAppointments />;
      case "/client/messages":
        return <ClientMessages />;
      case "/client/reports":
        return <ClientReports />;
      case "/client/profile":
        return <ClientProfile />;
      case "/client/dashboard":
      default:
        return <DashboardContent dashboardData={dashboardData} client={client} loading={loading} />;
    }
  };

  if (loading && location.pathname === "/client/dashboard") {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading your dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar for Desktop */}
      <div className="hidden lg:flex lg:flex-shrink-0">
        <div className="flex flex-col w-64">
          <div className="flex flex-col flex-grow bg-white border-r border-gray-200 pt-5 pb-4 overflow-y-auto">
            {/* Logo */}
            <div className="flex items-center flex-shrink-0 px-4">
              <div className="flex items-center space-x-3 cursor-pointer" onClick={() => navigate("/client/dashboard")}>
                <div className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-sm">A</span>
                </div>
                <span className="text-gray-900 font-bold text-lg">
                  Afrikonsults
                </span>
              </div>
            </div>

            {/* Navigation */}
            <div className="mt-8 flex-grow flex flex-col">
              <nav className="flex-1 px-4 space-y-2">
                {navigationItems.map((item) => {
                  const Icon = item.icon;
                  return (
                    <div
                      key={item.name}
                      onClick={() => navigate(item.href)}
                      className={`group flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors cursor-pointer ${
                        item.current
                          ? "bg-green-50 text-green-700 border border-green-200"
                          : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                      }`}
                    >
                      <Icon
                        className={`flex-shrink-0 h-5 w-5 ${
                          item.current
                            ? "text-green-500"
                            : "text-gray-400 group-hover:text-gray-500"
                        }`}
                      />
                      <span className="ml-3">{item.name}</span>
                    </div>
                  );
                })}
              </nav>
            </div>

            {/* User section */}
            <div className="flex-shrink-0 flex border-t border-gray-200 p-4">
              <div className="flex items-center w-full">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                    <FiUser className="text-green-600" size={16} />
                  </div>
                </div>
                <div className="ml-3 flex-1">
                  <p className="text-sm font-medium text-gray-900">
                    {client?.profile?.personalInfo?.fullName || "Client"}
                  </p>
                  <p className="text-xs text-gray-500 truncate">
                    {client?.email}
                  </p>
                </div>
                <button
                  onClick={logout}
                  className="ml-3 flex-shrink-0 p-1 text-gray-400 hover:text-gray-600"
                  title="Logout"
                >
                  <FiLogOut size={16} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile sidebar */}
      {sidebarOpen && (
        <div className="lg:hidden fixed inset-0 flex z-40">
          <div
            className="fixed inset-0 bg-gray-600 bg-opacity-75"
            onClick={() => setSidebarOpen(false)}
          />
          <div className="relative flex-1 flex flex-col max-w-xs w-full bg-white">
            <div className="absolute top-0 right-0 -mr-12 pt-2">
              <button
                className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                onClick={() => setSidebarOpen(false)}
              >
                <span className="sr-only">Close sidebar</span>
                <FiX className="h-6 w-6 text-white" />
              </button>
            </div>
            <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
              <div className="flex-shrink-0 flex items-center px-4">
                <div 
                  className="flex items-center space-x-3 cursor-pointer" 
                  onClick={() => {
                    navigate("/client/dashboard");
                    setSidebarOpen(false);
                  }}
                >
                  <div className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-500 rounded-lg flex items-center justify-center">
                    <span className="text-white font-bold text-sm">A</span>
                  </div>
                  <span className="text-gray-900 font-bold text-lg">
                    Afrikonsults
                  </span>
                </div>
              </div>
              <nav className="mt-8 px-4 space-y-2">
                {navigationItems.map((item) => {
                  const Icon = item.icon;
                  return (
                    <div
                      key={item.name}
                      onClick={() => {
                        navigate(item.href);
                        setSidebarOpen(false);
                      }}
                      className={`group flex items-center px-3 py-2 text-base font-medium rounded-lg transition-colors cursor-pointer ${
                        item.current
                          ? "bg-green-50 text-green-700 border border-green-200"
                          : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                      }`}
                    >
                      <Icon
                        className={`flex-shrink-0 h-6 w-6 ${
                          item.current
                            ? "text-green-500"
                            : "text-gray-400 group-hover:text-gray-500"
                        }`}
                      />
                      <span className="ml-3">{item.name}</span>
                    </div>
                  );
                })}
              </nav>
            </div>
            <div className="flex-shrink-0 flex border-t border-gray-200 p-4">
              <div className="flex items-center w-full">
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                    <FiUser className="text-green-600" size={16} />
                  </div>
                </div>
                <div className="ml-3 flex-1">
                  <p className="text-base font-medium text-gray-900">
                    {client?.profile?.personalInfo?.fullName || "Client"}
                  </p>
                  <p className="text-sm text-gray-500 truncate">
                    {client?.email}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main content area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top header */}
        <header className="bg-white shadow-sm border-b border-gray-200">
          <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
            <div className="flex items-center">
              <button
                type="button"
                className="lg:hidden px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500"
                onClick={() => setSidebarOpen(true)}
              >
                <span className="sr-only">Open sidebar</span>
                <FiMenu className="h-6 w-6" />
              </button>
              <div className="ml-4 lg:ml-0">
                <h1 className="text-xl font-semibold text-gray-900">
                  {navigationItems.find((item) => item.current)?.name || "Dashboard"}
                </h1>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <button className="p-2 text-gray-400 hover:text-gray-600 relative">
                <FiBell size={20} />
                {dashboardData?.stats.unreadMessages > 0 && (
                  <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
                )}
              </button>

              <div className="lg:hidden flex items-center space-x-3">
                <div className="text-right">
                  <p className="text-sm font-medium text-gray-900">
                    {client?.profile?.personalInfo?.fullName || "Client"}
                  </p>
                </div>
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                  <FiUser className="text-green-600" size={16} />
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Main content */}
        <main className="flex-1 overflow-auto bg-gray-50">
          <React.Suspense fallback={
            <div className="flex items-center justify-center h-64">
              <div className="w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          }>
            {renderCurrentPage()}
          </React.Suspense>
        </main>
      </div>
    </div>
  );
}

// Dashboard Content Component
function DashboardContent({ dashboardData, client, loading }) {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Welcome Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8"
      >
        <h1 className="text-3xl font-bold text-gray-900">
          Welcome back, {client?.profile?.personalInfo?.fullName || "Client"}!
        </h1>
        <p className="text-gray-600 mt-2">
          Here's what's happening with your farm and projects today.
        </p>
      </motion.div>

      {/* Stats Grid */}
      {dashboardData && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
          >
            <div className="flex items-center">
              <div className="p-3 bg-blue-100 rounded-lg">
                <FiBarChart2 className="text-blue-600" size={24} />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">
                  Active Projects
                </p>
                <p className="text-2xl font-bold text-gray-900">
                  {dashboardData.stats.activeProjects}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
          >
            <div className="flex items-center">
              <div className="p-3 bg-green-100 rounded-lg">
                <FiCalendar className="text-green-600" size={24} />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">
                  Upcoming Appointments
                </p>
                <p className="text-2xl font-bold text-gray-900">
                  {dashboardData.stats.upcomingAppointments}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
          >
            <div className="flex items-center">
              <div className="p-3 bg-purple-100 rounded-lg">
                <FiMessageSquare className="text-purple-600" size={24} />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">
                  Unread Messages
                </p>
                <p className="text-2xl font-bold text-gray-900">
                  {dashboardData.stats.unreadMessages}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
          >
            <div className="flex items-center">
              <div className="p-3 bg-orange-100 rounded-lg">
                <FiFileText className="text-orange-600" size={24} />
              </div>
              <div className="ml-4">
                <p className="text-sm font-medium text-gray-600">
                  Recent Reports
                </p>
                <p className="text-2xl font-bold text-gray-900">
                  {dashboardData.stats.recentReports}
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      )}

      {/* Quick Actions */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8"
      >
        {/* Recent Projects */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">
              Recent Projects
            </h3>
            <Link
              to="/client/projects"
              className="text-green-600 hover:text-green-700 text-sm font-medium"
            >
              View All
            </Link>
          </div>
          <div className="space-y-4">
            {dashboardData?.recentProjects?.map((project) => (
              <div
                key={project._id}
                className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg"
              >
                <div>
                  <p className="font-medium text-gray-900">{project.title}</p>
                  <p className="text-sm text-gray-500">
                    {project.assignedConsultant?.name}
                  </p>
                </div>
                <div className="text-right">
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      project.status === "active"
                        ? "bg-green-100 text-green-800"
                        : project.status === "completed"
                        ? "bg-gray-100 text-gray-800"
                        : "bg-yellow-100 text-yellow-800"
                    }`}
                  >
                    {project.status}
                  </span>
                  <div className="w-20 bg-gray-200 rounded-full h-2 mt-2">
                    <div
                      className="bg-green-600 h-2 rounded-full"
                      style={{
                        width: `${project.progress?.percentage || 0}%`,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            ))}
            {(!dashboardData?.recentProjects || dashboardData.recentProjects.length === 0) && (
              <div className="text-center py-4">
                <p className="text-gray-500 text-sm">No recent projects</p>
              </div>
            )}
          </div>
        </div>

        {/* Upcoming Appointments */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">
              Upcoming Appointments
            </h3>
            <Link
              to="/client/appointments"
              className="text-green-600 hover:text-green-700 text-sm font-medium"
            >
              Schedule
            </Link>
          </div>
          <div className="space-y-4">
            {dashboardData?.upcomingAppointments?.map((appointment) => (
              <div
                key={appointment._id}
                className="p-3 border border-gray-200 rounded-lg"
              >
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-medium text-gray-900">
                      {appointment.title}
                    </p>
                    <p className="text-sm text-gray-500">
                      {appointment.consultantId?.name}
                    </p>
                  </div>
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      appointment.status === "scheduled"
                        ? "bg-blue-100 text-blue-800"
                        : appointment.status === "confirmed"
                        ? "bg-green-100 text-green-800"
                        : "bg-gray-100 text-gray-800"
                    }`}
                  >
                    {appointment.status}
                  </span>
                </div>
                <div className="mt-2 text-sm text-gray-600">
                  {new Date(appointment.scheduledDate).toLocaleDateString()} •{" "}
                  {new Date(appointment.scheduledDate).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </div>
              </div>
            ))}
            {(!dashboardData?.upcomingAppointments || dashboardData.upcomingAppointments.length === 0) && (
              <div className="text-center py-4">
                <p className="text-gray-500 text-sm">No upcoming appointments</p>
              </div>
            )}
          </div>
        </div>

        {/* Recent Reports */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">
              Recent Reports
            </h3>
            <Link
              to="/client/reports"
              className="text-green-600 hover:text-green-700 text-sm font-medium"
            >
              View All
            </Link>
          </div>
          <div className="space-y-4">
            {dashboardData?.recentReports?.map((report) => (
              <div
                key={report._id}
                className="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg"
              >
                <div>
                  <p className="font-medium text-gray-900">{report.title}</p>
                  <p className="text-sm text-gray-500 capitalize">
                    {report.type.replace("-", " ")}
                  </p>
                </div>
                <Link
                  to="/client/reports"
                  className="text-green-600 hover:text-green-700"
                >
                  <FiArrowRight size={16} />
                </Link>
              </div>
            ))}
            {(!dashboardData?.recentReports || dashboardData.recentReports.length === 0) && (
              <div className="text-center py-4">
                <p className="text-gray-500 text-sm">No recent reports</p>
              </div>
            )}
          </div>
        </div>
      </motion.div>

      {/* Quick Links */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="grid grid-cols-2 md:grid-cols-4 gap-4"
      >
        <Link
          to="/client/profile"
          className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow text-center"
        >
          <FiUser className="w-6 h-6 text-green-600 mx-auto mb-2" />
          <span className="text-sm font-medium text-gray-900">Profile</span>
        </Link>
        <Link
          to="/client/projects"
          className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow text-center"
        >
          <FiTrendingUp className="w-6 h-6 text-blue-600 mx-auto mb-2" />
          <span className="text-sm font-medium text-gray-900">Projects</span>
        </Link>
        <Link
          to="/client/messages"
          className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow text-center"
        >
          <FiMessageSquare className="w-6 h-6 text-purple-600 mx-auto mb-2" />
          <span className="text-sm font-medium text-gray-900">Messages</span>
        </Link>
        <Link
          to="/client/appointments"
          className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow text-center"
        >
          <FiCalendar className="w-6 h-6 text-orange-600 mx-auto mb-2" />
          <span className="text-sm font-medium text-gray-900">
            Appointments
          </span>
        </Link>
      </motion.div>

      {/* Recent Activity */}
      {dashboardData?.recentActivity && dashboardData.recentActivity.length > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7 }}
          className="mt-8 bg-white rounded-lg shadow-sm border border-gray-200 p-6"
        >
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Recent Activity
          </h3>
          <div className="space-y-3">
            {dashboardData.recentActivity.map((activity, index) => (
              <div key={index} className="flex items-center space-x-3 p-3 hover:bg-gray-50 rounded-lg">
                <div className={`w-2 h-2 rounded-full ${
                  activity.type === 'project' ? 'bg-blue-500' :
                  activity.type === 'appointment' ? 'bg-green-500' :
                  activity.type === 'message' ? 'bg-purple-500' : 'bg-gray-500'
                }`}></div>
                <div className="flex-1">
                  <p className="text-sm text-gray-900">{activity.description}</p>
                  <p className="text-xs text-gray-500">
                    {new Date(activity.timestamp).toLocaleDateString()} at{' '}
                    {new Date(activity.timestamp).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      )}
    </div>
  );
}

export default ClientDashboard;